import React, { useState } from "react";
import "./PreOwnedDevices.css";
import preownedImage from "../../images/pre-owned-image.png";
import gradingMatter from "../../images/grading-matter.png";
import iphoneImagelocation from "../../images/preowned-location-image.png";
import biometricImage from "../../images/preowned-search-biometric.png";
import browserImage from "../../images/preowned-search-browser.png";
import searchImage from "../../images/preowned-search-image.png";
import dropImage from "../../images/preowned-drop-image.png";
import lockImage from "../../images/preowned-search-lock.png";
import cameraImage from "../../images/preowned-search-camera.png";
import wifiImage from "../../images/preowned-wifi.png";
import clockImage from "../../images/preowned-search-clock.png";
import micImage from "../../images/preowned-search-mic.png";
import signalImage from "../../images/preowned-search-signal.png";
import lcdImage from "../../images/preowned-search-lcd.png";
import checkImage from "../../images/preowned-search-check.png";
import powerImage from "../../images/preowned-search-power.png";
import simImage from "../../images/preowned-search-sim.png";
import glassImage from "../../images/preowned-search-glass.png";
import toggleImage from "../../images/preowned-search-toggle.png";
import movieImage from "../../images/preowned-search-movie.png";
import groupImage from "../../images/Group.png";
import gradeA from "../../images/grade-A.png";
import gradeB from "../../images/grade-B.png";
import gradeC from "../../images/grade-C.png";
import gradeD from "../../images/grade-D.png";
import gradeFace from "../../images/grade-face.png";
import aboveCondition from "../../images/condition-above.png";
import aboveGradingSpec from "../../images/grading-spec-above.png";
import besideCondition from "../../images/condition-beside.png";
import besideGradingSpec from "../../images/grading-spec-beside.png";
import warranty from "../../images/warrenty.png";
import dataWiped from "../../images/data-wiped-resell-ready.png";
import noIcloud from "../../images/no-icloud.png";
import mdm from "../../images/mdm-free.png";
import hardware from "../../images/hardware-testing-passed.png";
import sixtyPoint from "../../images/60-point.png";
import cleansn from "../../images/clean-esn.png";
import frp from "../../images/no-fpr.png";

const PreOwnedDevices = () => {
  const [selectedIcon, setSelectedIcon] = useState(0);
  const [selectedGrade, setSelectedGrade] = useState("A"); // Drop icon is selected by default

  const iconImageMap = {
    0: { src: dropImage, alt: "Drop test" },
    1: { src: searchImage, alt: "Search test" },
    2: { src: lockImage, alt: "Lock test" },
    4: { src: cameraImage, alt: "Camera test" },
    5: { src: wifiImage, alt: "Wi-Fi test" },
    6: { src: biometricImage, alt: "Biometric test" },
    7: { src: clockImage, alt: "Clock test" },
    8: { src: micImage, alt: "Microphone test" },
    9: { src: signalImage, alt: "Signal test" },
    10: { src: lcdImage, alt: "LCD test" },
    11: { src: checkImage, alt: "Check test" },
    12: { src: powerImage, alt: "Power test" },
    13: { src: simImage, alt: "SIM test" },
    14: { src: glassImage, alt: "Glass test" },
    15: { src: toggleImage, alt: "Toggle test" },
    16: { src: movieImage, alt: "Movie test" },
    17: { src: browserImage, alt: "Browser test" },
  };

  const currentIconImage = iconImageMap[selectedIcon] || {
    src: iphoneImagelocation,
    alt: "iPhone with water damage test",
  };

  const iconData = [
    {
      id: 0,
      name: "Drop",
      svg: (
        <svg
          width="34"
          height="41"
          viewBox="0 0 34 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.9906 2L27.6031 12.8403C29.7019 14.9827 31.1315 17.7128 31.7111 20.6852C32.2906 23.6576 31.9942 26.7389 30.8591 29.5392C29.7241 32.3395 27.8015 34.7331 25.3346 36.4171C22.8676 38.1011 19.9671 39 17 39C14.0329 39 11.1324 38.1011 8.66543 36.4171C6.19848 34.7331 4.2759 32.3395 3.14087 29.5392C2.00585 26.7389 1.70937 23.6576 2.28895 20.6852C2.86852 17.7128 4.29811 14.9827 6.39688 12.8403L16.9906 2Z"
            stroke={selectedIcon === 0 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 1,
      name: "Search",
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 35 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.7782 29.5564C23.3877 29.5564 29.5564 23.3877 29.5564 15.7782C29.5564 8.1687 23.3877 2 15.7782 2C8.1687 2 2 8.1687 2 15.7782C2 23.3877 8.1687 29.5564 15.7782 29.5564Z"
            stroke={selectedIcon === 1 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.9997 33.0017L25.5078 25.5098"
            stroke={selectedIcon === 1 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 2,
      name: "Lock",
      svg: (
        <svg
          width="31"
          height="35"
          viewBox="0 0 31 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.2917 15.958H4.70833C3.00546 15.958 1.625 17.3385 1.625 19.0413V29.833C1.625 31.5359 3.00546 32.9163 4.70833 32.9163H26.2917C27.9945 32.9163 29.375 31.5359 29.375 29.833V19.0413C29.375 17.3385 27.9945 15.958 26.2917 15.958Z"
            stroke={selectedIcon === 2 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.79102 15.958V9.79134C7.79102 7.74696 8.60314 5.78632 10.0487 4.34073C11.4943 2.89513 13.455 2.08301 15.4993 2.08301C17.5437 2.08301 19.5044 2.89513 20.95 4.34073C22.3956 5.78632 23.2077 7.74696 23.2077 9.79134V15.958"
            stroke={selectedIcon === 2 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 3,
      name: "Location",
      svg: (
        <svg
          width="28"
          height="34"
          viewBox="0 0 28 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26 14.333C26 23.6663 14 31.6663 14 31.6663C14 31.6663 2 23.6663 2 14.333C2 11.1504 3.26428 8.09816 5.51472 5.84773C7.76516 3.59729 10.8174 2.33301 14 2.33301C17.1826 2.33301 20.2348 3.59729 22.4853 5.84773C24.7357 8.09816 26 11.1504 26 14.333Z"
            stroke={selectedIcon === 3 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 18.333C16.2091 18.333 18 16.5421 18 14.333C18 12.1239 16.2091 10.333 14 10.333C11.7909 10.333 10 12.1239 10 14.333C10 16.5421 11.7909 18.333 14 18.333Z"
            stroke={selectedIcon === 3 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 4,
      name: "Camera",
      svg: (
        <svg
          width="32"
          height="26"
          viewBox="0 0 32 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30.6673 22.3333C30.6673 23.0406 30.3864 23.7189 29.8863 24.219C29.3862 24.719 28.7079 25 28.0007 25H4.00065C3.29341 25 2.61513 24.719 2.11503 24.219C1.61494 23.7189 1.33398 23.0406 1.33398 22.3333V7.66667C1.33398 6.95942 1.61494 6.28115 2.11503 5.78105C2.61513 5.28095 3.29341 5 4.00065 5H9.33398L12.0007 1H20.0007L22.6673 5H28.0007C28.7079 5 29.3862 5.28095 29.8863 5.78105C30.3864 6.28115 30.6673 6.95942 30.6673 7.66667V22.3333Z"
            stroke={selectedIcon === 4 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.9993 19.6667C18.9449 19.6667 21.3327 17.2789 21.3327 14.3333C21.3327 11.3878 18.9449 9 15.9993 9C13.0538 9 10.666 11.3878 10.666 14.3333C10.666 17.2789 13.0538 19.6667 15.9993 19.6667Z"
            stroke={selectedIcon === 4 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 5,
      name: "WIFI",
      svg: (
        <svg
          width="32"
          height="24"
          viewBox="0 0 32 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.66602 11.7331C9.30143 9.538 12.6228 8.33594 16.0527 8.33594C19.4825 8.33594 22.8039 9.538 25.4393 11.7331"
            stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.89258 6.99972C5.78914 3.56501 10.805 1.66992 15.9992 1.66992C21.1935 1.66992 26.2093 3.56501 30.1059 6.99972"
            stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.373 16.4803C12.7266 15.5186 14.3459 15.002 16.0064 15.002C17.6668 15.002 19.2861 15.5186 20.6397 16.4803"
            stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 21.667H16.0133"
            stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 6,
      name: "Fingerprint",
      svg: (
        <svg
          width="25"
          height="28"
          viewBox="0 0 25 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_667_3827)">
            <path
              d="M3.16869 5.65068C5.43948 3.79693 8.31467 2.57103 11.4718 2.27853L11.5336 2.2748C15.4437 2.28225 19.0411 3.56591 21.9047 5.71588L21.8661 5.68794C22.0553 5.82021 22.2928 5.89846 22.5496 5.89846C23.2004 5.89846 23.7294 5.38798 23.7294 4.76013C23.7294 4.3782 23.5344 4.04285 23.237 3.83605L23.2332 3.83419C20.078 1.44388 16.0501 0 11.6707 0C11.576 0 11.4814 0 11.3868 0.00186306H11.4003C7.66973 0.326036 4.33305 1.73451 1.67027 3.89381L1.6973 3.87331C1.42504 4.08384 1.25126 4.40428 1.25126 4.76386C1.25126 5.39171 1.78034 5.90219 2.43107 5.90219C2.71105 5.90219 2.96787 5.80717 3.17255 5.65068H3.16869ZM24.6949 9.45505C20.6727 5.19422 16.556 3.03493 12.4585 3.03493H12.416C8.33012 3.04984 4.25581 5.21286 0.30509 9.46251C0.115857 9.66185 0 9.93013 0 10.2226C0 10.8524 0.52908 11.361 1.17981 11.361C1.52738 11.361 1.84019 11.2156 2.05646 10.9846C5.54376 7.23242 9.03298 5.32278 12.4218 5.30973H12.4546C15.8627 5.30973 19.3925 7.22124 22.9493 10.9865C23.1656 11.2157 23.4765 11.3572 23.8202 11.3572C24.4709 11.3572 25 10.8468 25 10.2189C25 9.92455 24.8841 9.65626 24.6949 9.45505ZM18.9214 24.0578C17.4345 23.6796 16.1775 22.8766 15.2642 21.7941L15.2545 21.7811C14.3373 20.6129 13.7542 19.1542 13.6673 17.5706V17.5519C13.5977 16.9744 13.0918 16.5291 12.4797 16.5291C12.4411 16.5291 12.4044 16.531 12.3697 16.5328H12.3735C11.7749 16.5943 11.3134 17.0787 11.3134 17.6656C11.3134 17.7047 11.3154 17.7457 11.3192 17.783V17.7792C11.4563 19.8416 12.2248 21.7103 13.4375 23.2306L13.4201 23.2063C14.6578 24.6763 16.3416 25.7531 18.2726 26.2469L18.3382 26.2618C18.4251 26.2841 18.5255 26.2972 18.6279 26.2972H18.6298C19.2805 26.2972 19.8096 25.7867 19.8096 25.1588C19.8096 24.6316 19.4369 24.1863 18.931 24.0578H18.9214ZM16.5309 7.38333C15.2989 6.90824 13.8719 6.63251 12.3774 6.63251C11.8 6.63251 11.2323 6.6735 10.6781 6.75175L10.7399 6.74429C8.63134 7.08896 6.77377 7.9497 5.25797 9.18491L5.27535 9.17187C3.07986 10.9082 1.50807 13.306 0.884375 16.0484L0.868927 16.1286C0.780104 16.5347 0.706727 16.9446 0.644937 17.4457C0.615973 17.7494 0.600525 18.1015 0.600525 18.4574C0.600525 21.2632 1.59496 23.8454 3.26137 25.8929L3.24013 25.8668C3.45833 26.1295 3.79045 26.2953 4.1612 26.2953C4.81386 26.2953 5.34101 25.7848 5.34101 25.157C5.34101 24.885 5.24253 24.6353 5.07647 24.4397L5.0784 24.4415C3.75377 22.8188 2.95242 20.7434 2.95242 18.4909C2.95242 18.1947 2.96594 17.9003 2.99297 17.6116L2.99104 17.6488C3.03738 17.2986 3.09724 16.9502 3.17448 16.6055C3.69584 14.3009 4.98185 12.3428 6.75639 10.9418L6.7757 10.9287C7.9613 9.95808 9.43076 9.27247 11.047 9.00419L11.101 8.99674C11.4834 8.94271 11.9255 8.91104 12.3755 8.91104C13.5707 8.91104 14.71 9.13274 15.7565 9.53517L15.6948 9.51467C18.4908 10.5561 20.6264 12.7229 21.5359 15.4225L21.5552 15.4895C22.0379 16.9967 22.1557 19.6851 21.254 20.6372C21.1342 20.7639 20.8234 21.1067 19.8502 20.9073C19.2342 20.7471 18.707 20.4453 18.2861 20.041C17.9868 19.8062 17.7493 19.5137 17.589 19.1765L17.5832 19.1616C17.4983 18.871 17.45 18.5375 17.45 18.1928C17.45 18.1686 17.45 18.1462 17.45 18.122V18.1258C17.45 18.122 17.45 18.1183 17.45 18.1146C17.45 17.5631 17.3708 17.0284 17.226 16.5217L17.2357 16.5626C16.6931 15.1393 15.4881 14.0643 13.9897 13.6712L13.955 13.6637C13.4742 13.4923 12.9219 13.3936 12.3426 13.3936C11.9777 13.3936 11.6224 13.4327 11.2806 13.5072L11.3134 13.5016C10.3576 13.7699 9.55048 14.286 8.94609 14.9753L8.9403 14.9809C8.24322 15.6833 7.74118 16.5701 7.52298 17.5594L7.51719 17.5948C7.5056 17.7513 7.49981 17.932 7.49981 18.1146C7.49981 20.2571 8.37646 22.2003 9.8015 23.633L9.79957 23.6311C11.1068 25.1421 12.5203 26.4853 14.0573 27.6889L14.1133 27.7317C14.318 27.8994 14.5845 28.0037 14.878 28.0037C15.5306 28.0037 16.0578 27.4932 16.0578 26.8654C16.0578 26.517 15.8936 26.204 15.6388 25.9953L15.6368 25.9935C14.1654 24.8458 12.8601 23.6088 11.6861 22.2618L11.6494 22.2208C10.5314 21.1737 9.83626 19.7094 9.83626 18.0885C9.83626 18.0605 9.83626 18.0307 9.83626 18.0028V18.0065C9.98108 17.4197 10.2804 16.9129 10.6878 16.5105C10.9948 16.1453 11.4023 15.8677 11.8695 15.715L11.8869 15.7094C12.0221 15.6851 12.1766 15.6702 12.3368 15.6702C12.6574 15.6702 12.9644 15.728 13.2463 15.8342L13.2289 15.8286C14.0187 16.0093 14.654 16.5291 14.9706 17.2147L14.9764 17.2296C15.0479 17.5091 15.0884 17.8314 15.0884 18.163C15.0884 18.1798 15.0884 18.1984 15.0884 18.2133V18.2115C15.0884 18.2264 15.0884 18.2431 15.0884 18.2599C15.0884 18.8617 15.1888 19.4411 15.3742 19.9832L15.3626 19.9441C15.6658 20.6521 16.1176 21.2483 16.6853 21.7177L16.6911 21.7233C17.4094 22.3922 18.3073 22.8822 19.3095 23.1225L19.35 23.1299C19.6532 23.2194 20.0008 23.2697 20.3619 23.2697C21.3968 23.2697 22.3314 22.8468 22.988 22.1723L22.9899 22.1705C24.7162 20.3503 24.4072 16.6931 23.8047 14.8132C22.652 11.374 19.9988 8.68002 16.61 7.40941L16.5309 7.38333ZM6.62316 18.1444C6.6695 16.4006 7.52684 14.8579 8.83989 13.8444L8.85147 13.8351C9.35738 13.4197 9.94053 13.0675 10.5719 12.8067L10.6164 12.7899C11.3173 12.4937 12.1341 12.3223 12.9934 12.3223C13.9492 12.3223 14.8529 12.5366 15.6581 12.9166L15.6214 12.9017C17.4654 14.0102 18.6723 15.9553 18.6723 18.1742C18.6723 18.2767 18.6703 18.3791 18.6646 18.4816V18.4667C18.6646 18.4686 18.6646 18.4723 18.6646 18.4742C18.6646 19.0722 19.1666 19.5547 19.7845 19.5547C19.8231 19.5547 19.8617 19.5529 19.9004 19.5491H19.8965C20.5241 19.5212 21.0222 19.0238 21.0222 18.4127C21.0222 18.394 21.0222 18.3754 21.0222 18.3586V18.3605C21.0261 18.2729 21.028 18.1686 21.028 18.0643C21.028 14.9977 19.2979 12.3204 16.7297 10.8896L16.6892 10.8691C15.6098 10.3512 14.3392 10.0475 12.9953 10.0475C11.8097 10.0475 10.682 10.2841 9.65861 10.7089L9.71267 10.6884C8.8032 11.061 8.01923 11.5324 7.32409 12.1025L7.33761 12.0932C5.51865 13.5203 4.34464 15.6553 4.27126 18.0587V18.0717C4.38712 21.7904 6.08828 25.1029 8.74334 27.4206L8.75492 27.4299C8.9654 27.6255 9.25311 27.7448 9.56979 27.7448C10.2205 27.7448 10.7496 27.2343 10.7496 26.6064C10.7496 26.2841 10.6106 25.9916 10.3846 25.783C8.17757 23.8919 6.75832 21.1905 6.62509 18.1667L6.62316 18.1444Z"
              fill={selectedIcon === 6 ? "#BEC5BF" : "black"}
            />
          </g>
          <defs>
            <clipPath id="clip0_667_3827">
              <rect width="25" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 7,
      name: "Clock",
      svg: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6667 25.3333C20.11 25.3333 25.3333 20.11 25.3333 13.6667C25.3333 7.22334 20.11 2 13.6667 2C7.22334 2 2 7.22334 2 13.6667C2 20.11 7.22334 25.3333 13.6667 25.3333Z"
            stroke={selectedIcon === 7 ? "#BEC5BF" : "black"}
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.666 6.66699V13.667L18.3327 16.0003"
            stroke={selectedIcon === 7 ? "#BEC5BF" : "black"}
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 8,
      name: "MIC",
      svg: (
        <svg
          width="20"
          height="30"
          viewBox="0 0 20 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.75 12.5V15C18.75 17.3206 17.8281 19.5462 16.1872 21.1872C14.5462 22.8281 12.3206 23.75 10 23.75M10 23.75C7.67936 23.75 5.45376 22.8281 3.81282 21.1872C2.17187 19.5462 1.25 17.3206 1.25 15V12.5M10 23.75V28.75M5 28.75H15M10 1.25C9.00544 1.25 8.05161 1.64509 7.34835 2.34835C6.64509 3.05161 6.25 4.00544 6.25 5V15C6.25 15.9946 6.64509 16.9484 7.34835 17.6517C8.05161 18.3549 9.00544 18.75 10 18.75C10.9946 18.75 11.9484 18.3549 12.6517 17.6517C13.3549 16.9484 13.75 15.9946 13.75 15V5C13.75 4.00544 13.3549 3.05161 12.6517 2.34835C11.9484 1.64509 10.9946 1.25 10 1.25Z"
            stroke={selectedIcon === 8 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 9,
      name: "Signal",
      svg: (
        <svg
          width="41"
          height="35"
          viewBox="0 0 41 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="19.25"
            y="13.25"
            width="2"
            height="19"
            fill={selectedIcon === 9 ? "#BEC5BF" : "black"}
          />
          <path
            d="M17.25 34.25C17.25 33.1454 18.1454 32.25 19.25 32.25H21.25C22.3546 32.25 23.25 33.1454 23.25 34.25H17.25Z"
            fill={selectedIcon === 9 ? "#BEC5BF" : "black"}
          />
          <circle
            cx="20.25"
            cy="13.25"
            r="2"
            fill={selectedIcon === 9 ? "#BEC5BF" : "black"}
          />
          <path
            d="M10.25 22.25C8.31152 19.8635 7.25 16.8559 7.25 13.75C7.25 10.6441 8.31152 7.63648 10.25 5.25"
            stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.25 5.25C32.1885 7.63648 33.25 10.6441 33.25 13.75C33.25 16.8559 32.1885 19.8635 30.25 22.25"
            stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.25 26.25C3.02782 22.7972 1.25 18.3527 1.25 13.75C1.25 9.14733 3.02782 4.70277 6.25 1.25"
            stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.25 1.25C37.4722 4.70277 39.25 9.14732 39.25 13.75C39.25 18.3527 37.4722 22.7972 34.25 26.25"
            stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.25 18.25C13.5995 16.9353 13.25 15.3627 13.25 13.75C13.25 12.1373 13.5995 10.5647 14.25 9.25"
            stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.25 9.25C26.9005 10.5647 27.25 12.1373 27.25 13.75C27.25 15.3627 26.9005 16.9353 26.25 18.25"
            stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 10,
      name: "LCD",
      svg: (
        <svg
          width="39"
          height="32"
          viewBox="0 0 39 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.3732 18.89H14.6732V20H10.9732V13.02H12.3732V18.89ZM15.223 16.5C15.223 15.8133 15.3764 15.2 15.683 14.66C15.9964 14.1133 16.4197 13.69 16.953 13.39C17.493 13.0833 18.0964 12.93 18.763 12.93C19.543 12.93 20.2264 13.13 20.813 13.53C21.3997 13.93 21.8097 14.4833 22.043 15.19H20.433C20.273 14.8567 20.0464 14.6067 19.753 14.44C19.4664 14.2733 19.133 14.19 18.753 14.19C18.3464 14.19 17.983 14.2867 17.663 14.48C17.3497 14.6667 17.103 14.9333 16.923 15.28C16.7497 15.6267 16.663 16.0333 16.663 16.5C16.663 16.96 16.7497 17.3667 16.923 17.72C17.103 18.0667 17.3497 18.3367 17.663 18.53C17.983 18.7167 18.3464 18.81 18.753 18.81C19.133 18.81 19.4664 18.7267 19.753 18.56C20.0464 18.3867 20.273 18.1333 20.433 17.8H22.043C21.8097 18.5133 21.3997 19.07 20.813 19.47C20.233 19.8633 19.5497 20.06 18.763 20.06C18.0964 20.06 17.493 19.91 16.953 19.61C16.4197 19.3033 15.9964 18.88 15.683 18.34C15.3764 17.8 15.223 17.1867 15.223 16.5ZM25.6788 13.02C26.4122 13.02 27.0555 13.1633 27.6088 13.45C28.1688 13.7367 28.5988 14.1467 28.8988 14.68C29.2055 15.2067 29.3588 15.82 29.3588 16.52C29.3588 17.22 29.2055 17.8333 28.8988 18.36C28.5988 18.88 28.1688 19.2833 27.6088 19.57C27.0555 19.8567 26.4122 20 25.6788 20H23.2388V13.02H25.6788ZM25.6288 18.81C26.3622 18.81 26.9288 18.61 27.3288 18.21C27.7288 17.81 27.9288 17.2467 27.9288 16.52C27.9288 15.7933 27.7288 15.2267 27.3288 14.82C26.9288 14.4067 26.3622 14.2 25.6288 14.2H24.6388V18.81H25.6288Z"
            fill={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="0.5"
            y1="28"
            x2="0.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="5.5"
            y1="28"
            x2="5.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="9.5"
            y1="28"
            x2="9.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="14.5"
            y1="28"
            x2="14.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="18.5"
            y1="28"
            x2="18.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="22.5"
            y1="28"
            x2="22.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="26.5"
            y1="28"
            x2="26.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="30.5"
            y1="28"
            x2="30.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="34.5"
            y1="28"
            x2="34.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <rect
            x="0.75"
            y="6.75"
            width="37.5"
            height="19.5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
            strokeWidth="1.5"
          />
          <line
            x1="0.5"
            y1="3"
            x2="0.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="5.5"
            y1="3"
            x2="5.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="9.5"
            y1="3"
            x2="9.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="14.5"
            y1="3"
            x2="14.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="18.5"
            y1="3"
            x2="18.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="22.5"
            y1="3"
            x2="22.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="26.5"
            y1="3"
            x2="26.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="30.5"
            y1="3"
            x2="30.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="34.5"
            y1="3"
            x2="34.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="38.5"
            y1="3"
            x2="38.5"
            y2="5"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
          <line
            x1="38.5"
            y1="28"
            x2="38.5"
            y2="30"
            stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
          />
        </svg>
      ),
    },
    {
      id: 11,
      name: "Check BOX",
      svg: (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="23"
            height="23"
            rx="1"
            stroke={selectedIcon === 11 ? "#BEC5BF" : "black"}
            strokeWidth="2"
          />
          <path
            d="M17.6667 9L10.3333 16.3333L7 13"
            stroke={selectedIcon === 11 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 12,
      name: "POWEROFF",
      svg: (
        <svg
          width="20"
          height="22"
          viewBox="0 0 20 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.365 5.63965C17.6234 6.89844 18.4803 8.50209 18.8273 10.2478C19.1743 11.9936 18.9959 13.803 18.3146 15.4474C17.6334 17.0918 16.4798 18.4972 14.9998 19.486C13.5199 20.4748 11.7799 21.0026 10 21.0026C8.2201 21.0026 6.48016 20.4748 5.00018 19.486C3.5202 18.4972 2.36664 17.0918 1.68537 15.4474C1.00409 13.803 0.825693 11.9936 1.17272 10.2478C1.51975 8.50209 2.37663 6.89844 3.635 5.63965"
            stroke={selectedIcon === 11 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.0059 1V11"
            stroke={selectedIcon === 11 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 13,
      name: "SIM",
      svg: (
        <svg
          width="20"
          height="27"
          viewBox="0 0 20 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_671_3601)">
            <path
              d="M16.3234 14.0156H3.67758C3.27145 14.0156 2.94336 14.3504 2.94336 14.7649V23.253C2.94336 23.6674 3.27145 24.0022 3.67758 24.0022H16.3287C16.7349 24.0022 17.063 23.6674 17.063 23.253V14.7649C17.058 14.3504 16.7299 14.0156 16.3234 14.0156ZM15.5892 22.498H4.41214V20.8983H4.78719C5.19333 20.8983 5.52141 20.5635 5.52141 20.149C5.52141 19.7346 5.19333 19.3998 4.78719 19.3998H4.41214V17.9009H6.25597C6.66211 17.9009 6.99019 17.5661 6.99019 17.1517C6.99019 16.7372 6.66211 16.4024 6.25597 16.4024H4.41214V15.5148H15.5892V22.498Z"
              fill={selectedIcon === 12 ? "#BEC5BF" : "black"}
            />
            <path
              d="M5.11508 2.41309C4.70895 2.41309 4.38086 2.74789 4.38086 3.16234V6.48435C4.38086 6.8988 4.70895 7.239 5.11508 7.239C5.52122 7.239 5.84931 6.9042 5.84931 6.48975V3.16234C5.84931 2.74789 5.52122 2.41309 5.11508 2.41309Z"
              fill={selectedIcon === 12 ? "#BEC5BF" : "black"}
            />
            <path
              d="M8.59946 2.41309C8.19332 2.41309 7.86523 2.74789 7.86523 3.16234V6.48435C7.86523 6.8988 8.19332 7.239 8.59946 7.239C9.0056 7.239 9.33368 6.9042 9.33368 6.48975V3.16234C9.33368 2.74789 9.0056 2.41309 8.59946 2.41309Z"
              fill={selectedIcon === 12 ? "#BEC5BF" : "black"}
            />
            <path
              d="M12.078 2.41309C11.6718 2.41309 11.3438 2.74789 11.3438 3.16234V6.48435C11.3438 6.8988 11.6718 7.239 12.078 7.239C12.4841 7.239 12.8122 6.9042 12.8122 6.48975V3.16234C12.8122 2.74789 12.4841 2.41309 12.078 2.41309Z"
              fill={selectedIcon === 12 ? "#BEC5BF" : "black"}
            />
            <path
              d="M15.5624 2.41309C15.1563 2.41309 14.8282 2.74789 14.8282 3.16234V6.48435C14.8229 6.8988 15.1563 7.239 15.5624 7.239C15.9685 7.239 16.2966 6.9042 16.2966 6.48975V3.16234C16.297 2.74789 15.9685 2.41309 15.5624 2.41309Z"
              fill={selectedIcon === 12 ? "#BEC5BF" : "black"}
            />
            <path
              d="M20 9.49253V2.24809C20 1.0098 19.0105 0 17.797 0H3.00536C2.81254 0 2.62502 0.07965 2.48446 0.218025L0.213653 2.5299C0.0780527 2.66828 0 2.8593 0 3.06146V9.49253C0 10.3164 0.838405 10.2418 0.838405 10.2418V11.714C0.838405 11.714 0 11.6768 0 12.4632V24.7462C0 25.9902 0.989549 27 2.203 27H17.7917C19.0052 27 19.9947 25.9902 19.9947 24.7519V12.4635C19.9947 11.6292 19.1613 11.7143 19.1613 11.7143V10.2421C19.1669 10.2418 20 10.311 20 9.49253ZM18.5312 24.7465C18.5312 25.161 18.2031 25.4958 17.797 25.4958H2.203C1.79686 25.4958 1.46878 25.161 1.46878 24.7465V13.2131C1.46878 13.2131 2.30718 13.2236 2.30718 12.4639V9.49286C2.30718 8.71155 1.46878 8.74361 1.46878 8.74361V3.3696L3.30202 1.49884H17.7917C18.1978 1.49884 18.5259 1.83364 18.5259 2.24809V8.74294C18.4591 8.74294 17.6978 8.76049 17.6978 9.49219V12.4632C17.6978 13.2658 18.5312 13.2125 18.5312 13.2125V24.7465Z"
              fill={selectedIcon === 12 ? "#BEC5BF" : "black"}
            />
          </g>
          <defs>
            <clipPath id="clip0_671_3601">
              <rect width="20" height="27" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 14,
      name: "Phone",
      svg: (
        <svg
          width="18"
          height="25"
          viewBox="0 0 18 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.7143 1H3.28571C2.02335 1 1 2.02335 1 3.28571V21.5714C1 22.8338 2.02335 23.8571 3.28571 23.8571H14.7143C15.9767 23.8571 17 22.8338 17 21.5714V3.28571C17 2.02335 15.9767 1 14.7143 1Z"
            stroke={selectedIcon === 14 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 19.2861H9.01143"
            stroke={selectedIcon === 14 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 15,
      name: "Toggle",
      svg: (
        <svg
          width="26"
          height="36"
          viewBox="0 0 26 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 1H8C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15H16C19.866 15 23 11.866 23 8C23 4.13401 19.866 1 16 1Z"
            stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
            stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.1211 20.3398H9.12109C5.2551 20.3398 2.12109 23.4739 2.12109 27.3398C2.12109 31.2058 5.2551 34.3398 9.12109 34.3398H17.1211C20.9871 34.3398 24.1211 31.2058 24.1211 27.3398C24.1211 23.4739 20.9871 20.3398 17.1211 20.3398Z"
            stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.1211 30.3398C18.7779 30.3398 20.1211 28.9967 20.1211 27.3398C20.1211 25.683 18.7779 24.3398 17.1211 24.3398C15.4642 24.3398 14.1211 25.683 14.1211 27.3398C14.1211 28.9967 15.4642 30.3398 17.1211 30.3398Z"
            stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 16,
      name: "Camera",
      svg: (
        <svg
          width="26"
          height="17"
          viewBox="0 0 26 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 3L17 8.5L25 14V3Z"
            stroke={selectedIcon === 16 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.8667 1H3.13333C1.95513 1 1 1.95939 1 3.14286V13.8571C1 15.0406 1.95513 16 3.13333 16H14.8667C16.0449 16 17 15.0406 17 13.8571V3.14286C17 1.95939 16.0449 1 14.8667 1Z"
            stroke={selectedIcon === 16 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 17,
      name: "Browser",
      svg: (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.1667 19.3333C15.2293 19.3333 19.3333 15.2293 19.3333 10.1667C19.3333 5.10406 15.2293 1 10.1667 1C5.10406 1 1 5.10406 1 10.1667C1 15.2293 5.10406 19.3333 10.1667 19.3333Z"
            stroke={selectedIcon === 17 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 10.167H19.3333"
            stroke={selectedIcon === 17 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.1667 1C12.4595 3.51016 13.7625 6.7677 13.8333 10.1667C13.7625 13.5656 12.4595 16.8232 10.1667 19.3333C7.87383 16.8232 6.57081 13.5656 6.5 10.1667C6.57081 6.7677 7.87383 3.51016 10.1667 1Z"
            stroke={selectedIcon === 17 ? "#BEC5BF" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];
  void iconData;

  return (
    <div className="preowned-devices">
      <div className="preowned-container">
        {/* Left Column - Image Section */}
        <div className="preowned-left-column">
          <div className="preowned-image-container">
            <img
              src={preownedImage}
              alt="Pre-owned devices showcase"
              className="preowned-main-image"
            />
          </div>
        </div>

        {/* Middle Column - Main Content */}
        <div className="preowned-middle-column">
          <div className="preowned-content">
            <div className="preowned-headline">
              <span className="highlight-number">60+</span>
              <span className="highlight-text">POINT</span>
            </div>

            <div className="preowned-title">
              <div>PRE-OWNED</div>
              <div>DEVICES</div>
            </div>

            <div className="preowned-divider"></div>

            <div className="grading-scale-title">Grading Scale</div>
          </div>
        </div>

        {/* Right Column - Feature List */}
        <div className="preowned-right-column">
          <div className="preowned-features">
            <div className="feature-item">
              <div className="feature-indicator"></div>
              <span>Graded</span>
            </div>
            <div className="feature-item">
              <div className="feature-indicator"></div>
              <span>Tested</span>
            </div>
            <div className="feature-item">
              <div className="feature-indicator"></div>
              <span>Boxed</span>
            </div>
            <div className="feature-item">
              <div className="feature-indicator"></div>
              <span>Ready To Resell</span>
            </div>
          </div>
        </div>
      </div>

      {/* New Section: Why Does Grading Matter? */}
      <div className="grading-matter-section">
        <div className="grading-left-column">
          <div className="grading-content">
            <h2 className="grading-title">Why Does Grading Matter?</h2>
            <p className="grading-text">
              Each Device Has Its Own Grading Scale Making It Easy For You To
              Decide What Is Right For Your Market.
            </p>
            <p className="grading-text">
              We Understand Prices Are Driven By Your Market And We Also
              Understand Each Customer Has Different Needs. That Is Why We Offer
              A Variety Of Grades For Your Convenience.
            </p>
          </div>
        </div>

        <div className="grading-right-column">
          <img
            src={gradingMatter}
            alt="Grading Matter Devices"
            className="grading-image"
          />
        </div>
      </div>

      {/* New Section: Software Tested */}
      <div className="software-tested-section">
        <div className="software-left-column">
          <img
            src={currentIconImage.src}
            alt={currentIconImage.alt}
            className="iphone-image"
          />
        </div>

        <div className="software-middle-column">
          <div className="diagnostic-panel">
            <div className="diagnostic-icons">
              {/* Drop */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 0 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(0)}
              >
                <svg
                  width="34"
                  height="41"
                  viewBox="0 0 34 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.9906 2L27.6031 12.8403C29.7019 14.9827 31.1315 17.7128 31.7111 20.6852C32.2906 23.6576 31.9942 26.7389 30.8591 29.5392C29.7241 32.3395 27.8015 34.7331 25.3346 36.4171C22.8676 38.1011 19.9671 39 17 39C14.0329 39 11.1324 38.1011 8.66543 36.4171C6.19848 34.7331 4.2759 32.3395 3.14087 29.5392C2.00585 26.7389 1.70937 23.6576 2.28895 20.6852C2.86852 17.7128 4.29811 14.9827 6.39688 12.8403L16.9906 2Z"
                    stroke={selectedIcon === 0 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Search */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 1 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(1)}
              >
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7782 29.5564C23.3877 29.5564 29.5564 23.3877 29.5564 15.7782C29.5564 8.1687 23.3877 2 15.7782 2C8.1687 2 2 8.1687 2 15.7782C2 23.3877 8.1687 29.5564 15.7782 29.5564Z"
                    stroke={selectedIcon === 1 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M32.9997 33.0017L25.5078 25.5098"
                    stroke={selectedIcon === 1 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Lock */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 2 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(2)}
              >
                <svg
                  width="31"
                  height="35"
                  viewBox="0 0 31 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.2917 15.958H4.70833C3.00546 15.958 1.625 17.3385 1.625 19.0413V29.833C1.625 31.5359 3.00546 32.9163 4.70833 32.9163H26.2917C27.9945 32.9163 29.375 31.5359 29.375 29.833V19.0413C29.375 17.3385 27.9945 15.958 26.2917 15.958Z"
                    stroke={selectedIcon === 2 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.79102 15.958V9.79134C7.79102 7.74696 8.60314 5.78632 10.0487 4.34073C11.4943 2.89513 13.455 2.08301 15.4993 2.08301C17.5437 2.08301 19.5044 2.89513 20.95 4.34073C22.3956 5.78632 23.2077 7.74696 23.2077 9.79134V15.958"
                    stroke={selectedIcon === 2 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Location */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 3 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(3)}
              >
                <svg
                  width="28"
                  height="34"
                  viewBox="0 0 28 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26 14.333C26 23.6663 14 31.6663 14 31.6663C14 31.6663 2 23.6663 2 14.333C2 11.1504 3.26428 8.09816 5.51472 5.84773C7.76516 3.59729 10.8174 2.33301 14 2.33301C17.1826 2.33301 20.2348 3.59729 22.4853 5.84773C24.7357 8.09816 26 11.1504 26 14.333Z"
                    stroke={selectedIcon === 3 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 18.333C16.2091 18.333 18 16.5421 18 14.333C18 12.1239 16.2091 10.333 14 10.333C11.7909 10.333 10 12.1239 10 14.333C10 16.5421 11.7909 18.333 14 18.333Z"
                    stroke={selectedIcon === 3 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Camera */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 4 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(4)}
              >
                <svg
                  width="32"
                  height="26"
                  viewBox="0 0 32 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30.6673 22.3333C30.6673 23.0406 30.3864 23.7189 29.8863 24.219C29.3862 24.719 28.7079 25 28.0007 25H4.00065C3.29341 25 2.61513 24.719 2.11503 24.219C1.61494 23.7189 1.33398 23.0406 1.33398 22.3333V7.66667C1.33398 6.95942 1.61494 6.28115 2.11503 5.78105C2.61513 5.28095 3.29341 5 4.00065 5H9.33398L12.0007 1H20.0007L22.6673 5H28.0007C28.7079 5 29.3862 5.28095 29.8863 5.78105C30.3864 6.28115 30.6673 6.95942 30.6673 7.66667V22.3333Z"
                    stroke={selectedIcon === 4 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.9993 19.6667C18.9449 19.6667 21.3327 17.2789 21.3327 14.3333C21.3327 11.3878 18.9449 9 15.9993 9C13.0538 9 10.666 11.3878 10.666 14.3333C10.666 17.2789 13.0538 19.6667 15.9993 19.6667Z"
                    stroke={selectedIcon === 4 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* WIFI */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 5 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(5)}
              >
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.66602 11.7331C9.30143 9.538 12.6228 8.33594 16.0527 8.33594C19.4825 8.33594 22.8039 9.538 25.4393 11.7331"
                    stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.89258 6.99972C5.78914 3.56501 10.805 1.66992 15.9992 1.66992C21.1935 1.66992 26.2093 3.56501 30.1059 6.99972"
                    stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.373 16.4803C12.7266 15.5186 14.3459 15.002 16.0064 15.002C17.6668 15.002 19.2861 15.5186 20.6397 16.4803"
                    stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 21.667H16.0133"
                    stroke={selectedIcon === 5 ? "#BEC5BF" : "black"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Fingerprint */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 6 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(6)}
              >
                <svg
                  width="25"
                  height="28"
                  viewBox="0 0 25 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_667_3827)">
                    <path
                      d="M3.16869 5.65068C5.43948 3.79693 8.31467 2.57103 11.4718 2.27853L11.5336 2.2748C15.4437 2.28225 19.0411 3.56591 21.9047 5.71588L21.8661 5.68794C22.0553 5.82021 22.2928 5.89846 22.5496 5.89846C23.2004 5.89846 23.7294 5.38798 23.7294 4.76013C23.7294 4.3782 23.5344 4.04285 23.237 3.83605L23.2332 3.83419C20.078 1.44388 16.0501 0 11.6707 0C11.576 0 11.4814 0 11.3868 0.00186306H11.4003C7.66973 0.326036 4.33305 1.73451 1.67027 3.89381L1.6973 3.87331C1.42504 4.08384 1.25126 4.40428 1.25126 4.76386C1.25126 5.39171 1.78034 5.90219 2.43107 5.90219C2.71105 5.90219 2.96787 5.80717 3.17255 5.65068H3.16869ZM24.6949 9.45505C20.6727 5.19422 16.556 3.03493 12.4585 3.03493H12.416C8.33012 3.04984 4.25581 5.21286 0.30509 9.46251C0.115857 9.66185 0 9.93013 0 10.2226C0 10.8524 0.52908 11.361 1.17981 11.361C1.52738 11.361 1.84019 11.2156 2.05646 10.9846C5.54376 7.23242 9.03298 5.32278 12.4218 5.30973H12.4546C15.8627 5.30973 19.3925 7.22124 22.9493 10.9865C23.1656 11.2157 23.4765 11.3572 23.8202 11.3572C24.4709 11.3572 25 10.8468 25 10.2189C25 9.92455 24.8841 9.65626 24.6949 9.45505ZM18.9214 24.0578C17.4345 23.6796 16.1775 22.8766 15.2642 21.7941L15.2545 21.7811C14.3373 20.6129 13.7542 19.1542 13.6673 17.5706V17.5519C13.5977 16.9744 13.0918 16.5291 12.4797 16.5291C12.4411 16.5291 12.4044 16.531 12.3697 16.5328H12.3735C11.7749 16.5943 11.3134 17.0787 11.3134 17.6656C11.3134 17.7047 11.3154 17.7457 11.3192 17.783V17.7792C11.4563 19.8416 12.2248 21.7103 13.4375 23.2306L13.4201 23.2063C14.6578 24.6763 16.3416 25.7531 18.2726 26.2469L18.3382 26.2618C18.4251 26.2841 18.5255 26.2972 18.6279 26.2972H18.6298C19.2805 26.2972 19.8096 25.7867 19.8096 25.1588C19.8096 24.6316 19.4369 24.1863 18.931 24.0578H18.9214ZM16.5309 7.38333C15.2989 6.90824 13.8719 6.63251 12.3774 6.63251C11.8 6.63251 11.2323 6.6735 10.6781 6.75175L10.7399 6.74429C8.63134 7.08896 6.77377 7.9497 5.25797 9.18491L5.27535 9.17187C3.07986 10.9082 1.50807 13.306 0.884375 16.0484L0.868927 16.1286C0.780104 16.5347 0.706727 16.9446 0.644937 17.4457C0.615973 17.7494 0.600525 18.1015 0.600525 18.4574C0.600525 21.2632 1.59496 23.8454 3.26137 25.8929L3.24013 25.8668C3.45833 26.1295 3.79045 26.2953 4.1612 26.2953C4.81386 26.2953 5.34101 25.7848 5.34101 25.157C5.34101 24.885 5.24253 24.6353 5.07647 24.4397L5.0784 24.4415C3.75377 22.8188 2.95242 20.7434 2.95242 18.4909C2.95242 18.1947 2.96594 17.9003 2.99297 17.6116L2.99104 17.6488C3.03738 17.2986 3.09724 16.9502 3.17448 16.6055C3.69584 14.3009 4.98185 12.3428 6.75639 10.9418L6.7757 10.9287C7.9613 9.95808 9.43076 9.27247 11.047 9.00419L11.101 8.99674C11.4834 8.94271 11.9255 8.91104 12.3755 8.91104C13.5707 8.91104 14.71 9.13274 15.7565 9.53517L15.6948 9.51467C18.4908 10.5561 20.6264 12.7229 21.5359 15.4225L21.5552 15.4895C22.0379 16.9967 22.1557 19.6851 21.254 20.6372C21.1342 20.7639 20.8234 21.1067 19.8502 20.9073C19.2342 20.7471 18.707 20.4453 18.2861 20.041C17.9868 19.8062 17.7493 19.5137 17.589 19.1765L17.5832 19.1616C17.4983 18.871 17.45 18.5375 17.45 18.1928C17.45 18.1686 17.45 18.1462 17.45 18.122V18.1258C17.45 18.122 17.45 18.1183 17.45 18.1146C17.45 17.5631 17.3708 17.0284 17.226 16.5217L17.2357 16.5626C16.6931 15.1393 15.4881 14.0643 13.9897 13.6712L13.955 13.6637C13.4742 13.4923 12.9219 13.3936 12.3426 13.3936C11.9777 13.3936 11.6224 13.4327 11.2806 13.5072L11.3134 13.5016C10.3576 13.7699 9.55048 14.286 8.94609 14.9753L8.9403 14.9809C8.24322 15.6833 7.74118 16.5701 7.52298 17.5594L7.51719 17.5948C7.5056 17.7513 7.49981 17.932 7.49981 18.1146C7.49981 20.2571 8.37646 22.2003 9.8015 23.633L9.79957 23.6311C11.1068 25.1421 12.5203 26.4853 14.0573 27.6889L14.1133 27.7317C14.318 27.8994 14.5845 28.0037 14.878 28.0037C15.5306 28.0037 16.0578 27.4932 16.0578 26.8654C16.0578 26.517 15.8936 26.204 15.6388 25.9953L15.6368 25.9935C14.1654 24.8458 12.8601 23.6088 11.6861 22.2618L11.6494 22.2208C10.5314 21.1737 9.83626 19.7094 9.83626 18.0885C9.83626 18.0605 9.83626 18.0307 9.83626 18.0028V18.0065C9.98108 17.4197 10.2804 16.9129 10.6878 16.5105C10.9948 16.1453 11.4023 15.8677 11.8695 15.715L11.8869 15.7094C12.0221 15.6851 12.1766 15.6702 12.3368 15.6702C12.6574 15.6702 12.9644 15.728 13.2463 15.8342L13.2289 15.8286C14.0187 16.0093 14.654 16.5291 14.9706 17.2147L14.9764 17.2296C15.0479 17.5091 15.0884 17.8314 15.0884 18.163C15.0884 18.1798 15.0884 18.1984 15.0884 18.2133V18.2115C15.0884 18.2264 15.0884 18.2431 15.0884 18.2599C15.0884 18.8617 15.1888 19.4411 15.3742 19.9832L15.3626 19.9441C15.6658 20.6521 16.1176 21.2483 16.6853 21.7177L16.6911 21.7233C17.4094 22.3922 18.3073 22.8822 19.3095 23.1225L19.35 23.1299C19.6532 23.2194 20.0008 23.2697 20.3619 23.2697C21.3968 23.2697 22.3314 22.8468 22.988 22.1723L22.9899 22.1705C24.7162 20.3503 24.4072 16.6931 23.8047 14.8132C22.652 11.374 19.9988 8.68002 16.61 7.40941L16.5309 7.38333ZM6.62316 18.1444C6.6695 16.4006 7.52684 14.8579 8.83989 13.8444L8.85147 13.8351C9.35738 13.4197 9.94053 13.0675 10.5719 12.8067L10.6164 12.7899C11.3173 12.4937 12.1341 12.3223 12.9934 12.3223C13.9492 12.3223 14.8529 12.5366 15.6581 12.9166L15.6214 12.9017C17.4654 14.0102 18.6723 15.9553 18.6723 18.1742C18.6723 18.2767 18.6703 18.3791 18.6646 18.4816V18.4667C18.6646 18.4686 18.6646 18.4723 18.6646 18.4742C18.6646 19.0722 19.1666 19.5547 19.7845 19.5547C19.8231 19.5547 19.8617 19.5529 19.9004 19.5491H19.8965C20.5241 19.5212 21.0222 19.0238 21.0222 18.4127C21.0222 18.394 21.0222 18.3754 21.0222 18.3586V18.3605C21.0261 18.2729 21.028 18.1686 21.028 18.0643C21.028 14.9977 19.2979 12.3204 16.7297 10.8896L16.6892 10.8691C15.6098 10.3512 14.3392 10.0475 12.9953 10.0475C11.8097 10.0475 10.682 10.2841 9.65861 10.7089L9.71267 10.6884C8.8032 11.061 8.01923 11.5324 7.32409 12.1025L7.33761 12.0932C5.51865 13.5203 4.34464 15.6553 4.27126 18.0587V18.0717C4.38712 21.7904 6.08828 25.1029 8.74334 27.4206L8.75492 27.4299C8.9654 27.6255 9.25311 27.7448 9.56979 27.7448C10.2205 27.7448 10.7496 27.2343 10.7496 26.6064C10.7496 26.2841 10.6106 25.9916 10.3846 25.783C8.17757 23.8919 6.75832 21.1905 6.62509 18.1667L6.62316 18.1444Z"
                      fill={selectedIcon === 6 ? "#BEC5BF" : "black"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_667_3827">
                      <rect width="25" height="28" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              {/* Clock */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 7 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(7)}
              >
                <svg
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.6667 25.3333C20.11 25.3333 25.3333 20.11 25.3333 13.6667C25.3333 7.22334 20.11 2 13.6667 2C7.22334 2 2 7.22334 2 13.6667C2 20.11 7.22334 25.3333 13.6667 25.3333Z"
                    stroke={selectedIcon === 7 ? "#BEC5BF" : "black"}
                    strokeWidth="2.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.666 6.66699V13.667L18.3327 16.0003"
                    stroke={selectedIcon === 7 ? "#BEC5BF" : "black"}
                    strokeWidth="2.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* MIC */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 8 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(8)}
              >
                <svg
                  width="20"
                  height="30"
                  viewBox="0 0 20 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.75 12.5V15C18.75 17.3206 17.8281 19.5462 16.1872 21.1872C14.5462 22.8281 12.3206 23.75 10 23.75M10 23.75C7.67936 23.75 5.45376 22.8281 3.81282 21.1872C2.17187 19.5462 1.25 17.3206 1.25 15V12.5M10 23.75V28.75M5 28.75H15M10 1.25C9.00544 1.25 8.05161 1.64509 7.34835 2.34835C6.64509 3.05161 6.25 4.00544 6.25 5V15C6.25 15.9946 6.64509 16.9484 7.34835 17.6517C8.05161 18.3549 9.00544 18.75 10 18.75C10.9946 18.75 11.9484 18.3549 12.6517 17.6517C13.3549 16.9484 13.75 15.9946 13.75 15V5C13.75 4.00544 13.3549 3.05161 12.6517 2.34835C11.9484 1.64509 10.9946 1.25 10 1.25Z"
                    stroke={selectedIcon === 8 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Signal */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 9 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(9)}
              >
                <svg
                  width="41"
                  height="35"
                  viewBox="0 0 41 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="19.25"
                    y="13.25"
                    width="2"
                    height="19"
                    fill={selectedIcon === 9 ? "#BEC5BF" : "black"}
                  />
                  <path
                    d="M17.25 34.25C17.25 33.1454 18.1454 32.25 19.25 32.25H21.25C22.3546 32.25 23.25 33.1454 23.25 34.25H17.25Z"
                    fill={selectedIcon === 9 ? "#BEC5BF" : "black"}
                  />
                  <circle
                    cx="20.25"
                    cy="13.25"
                    r="2"
                    fill={selectedIcon === 9 ? "#BEC5BF" : "black"}
                  />
                  <path
                    d="M10.25 22.25C8.31152 19.8635 7.25 16.8559 7.25 13.75C7.25 10.6441 8.31152 7.63648 10.25 5.25"
                    stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M30.25 5.25C32.1885 7.63648 33.25 10.6441 33.25 13.75C33.25 16.8559 32.1885 19.8635 30.25 22.25"
                    stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.25 26.25C3.02782 22.7972 1.25 18.3527 1.25 13.75C1.25 9.14733 3.02782 4.70277 6.25 1.25"
                    stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M34.25 1.25C37.4722 4.70277 39.25 9.14732 39.25 13.75C39.25 18.3527 37.4722 22.7972 34.25 26.25"
                    stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.25 18.25C13.5995 16.9353 13.25 15.3627 13.25 13.75C13.25 12.1373 13.5995 10.5647 14.25 9.25"
                    stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M26.25 9.25C26.9005 10.5647 27.25 12.1373 27.25 13.75C27.25 15.3627 26.9005 16.9353 26.25 18.25"
                    stroke={selectedIcon === 9 ? "#BEC5BF" : "black"}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* LCD */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 10 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(10)}
              >
                <svg
                  width="39"
                  height="32"
                  viewBox="0 0 39 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.3732 18.89H14.6732V20H10.9732V13.02H12.3732V18.89ZM15.223 16.5C15.223 15.8133 15.3764 15.2 15.683 14.66C15.9964 14.1133 16.4197 13.69 16.953 13.39C17.493 13.0833 18.0964 12.93 18.763 12.93C19.543 12.93 20.2264 13.13 20.813 13.53C21.3997 13.93 21.8097 14.4833 22.043 15.19H20.433C20.273 14.8567 20.0464 14.6067 19.753 14.44C19.4664 14.2733 19.133 14.19 18.753 14.19C18.3464 14.19 17.983 14.2867 17.663 14.48C17.3497 14.6667 17.103 14.9333 16.923 15.28C16.7497 15.6267 16.663 16.0333 16.663 16.5C16.663 16.96 16.7497 17.3667 16.923 17.72C17.103 18.0667 17.3497 18.3367 17.663 18.53C17.983 18.7167 18.3464 18.81 18.753 18.81C19.133 18.81 19.4664 18.7267 19.753 18.56C20.0464 18.3867 20.273 18.1333 20.433 17.8H22.043C21.8097 18.5133 21.3997 19.07 20.813 19.47C20.233 19.8633 19.5497 20.06 18.763 20.06C18.0964 20.06 17.493 19.91 16.953 19.61C16.4197 19.3033 15.9964 18.88 15.683 18.34C15.3764 17.8 15.223 17.1867 15.223 16.5ZM25.6788 13.02C26.4122 13.02 27.0555 13.1633 27.6088 13.45C28.1688 13.7367 28.5988 14.1467 28.8988 14.68C29.2055 15.2067 29.3588 15.82 29.3588 16.52C29.3588 17.22 29.2055 17.8333 28.8988 18.36C28.5988 18.88 28.1688 19.2833 27.6088 19.57C27.0555 19.8567 26.4122 20 25.6788 20H23.2388V13.02H25.6788ZM25.6288 18.81C26.3622 18.81 26.9288 18.61 27.3288 18.21C27.7288 17.81 27.9288 17.2467 27.9288 16.52C27.9288 15.7933 27.7288 15.2267 27.3288 14.82C26.9288 14.4067 26.3622 14.2 25.6288 14.2H24.6388V18.81H25.6288Z"
                    fill={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="0.5"
                    y1="28"
                    x2="0.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="5.5"
                    y1="28"
                    x2="5.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="9.5"
                    y1="28"
                    x2="9.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="14.5"
                    y1="28"
                    x2="14.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="18.5"
                    y1="28"
                    x2="18.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="22.5"
                    y1="28"
                    x2="22.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="26.5"
                    y1="28"
                    x2="26.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="30.5"
                    y1="28"
                    x2="30.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="34.5"
                    y1="28"
                    x2="34.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <rect
                    x="0.75"
                    y="6.75"
                    width="37.5"
                    height="19.5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                    strokeWidth="1.5"
                  />
                  <line
                    x1="0.5"
                    y1="3"
                    x2="0.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="5.5"
                    y1="3"
                    x2="5.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="9.5"
                    y1="3"
                    x2="9.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="14.5"
                    y1="3"
                    x2="14.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="18.5"
                    y1="3"
                    x2="18.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="22.5"
                    y1="3"
                    x2="22.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="26.5"
                    y1="3"
                    x2="26.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="30.5"
                    y1="3"
                    x2="30.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="34.5"
                    y1="3"
                    x2="34.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="38.5"
                    y1="3"
                    x2="38.5"
                    y2="5"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                  <line
                    x1="38.5"
                    y1="28"
                    x2="38.5"
                    y2="30"
                    stroke={selectedIcon === 10 ? "#BEC5BF" : "black"}
                  />
                </svg>
              </div>

              {/* Check BOX */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 11 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(11)}
              >
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="1"
                    width="23"
                    height="23"
                    rx="1"
                    stroke={selectedIcon === 11 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                  />
                  <path
                    d="M17.6667 9L10.3333 16.3333L7 13"
                    stroke={selectedIcon === 11 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* POWEROFF */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 12 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(12)}
              >
                <svg
                  width="20"
                  height="22"
                  viewBox="0 0 20 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.365 5.63965C17.6234 6.89844 18.4803 8.50209 18.8273 10.2478C19.1743 11.9936 18.9959 13.803 18.3146 15.4474C17.6334 17.0918 16.4798 18.4972 14.9998 19.486C13.5199 20.4748 11.7799 21.0026 10 21.0026C8.2201 21.0026 6.48016 20.4748 5.00018 19.486C3.5202 18.4972 2.36664 17.0918 1.68537 15.4474C1.00409 13.803 0.825693 11.9936 1.17272 10.2478C1.51975 8.50209 2.37663 6.89844 3.635 5.63965"
                    stroke={selectedIcon === 12 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.0059 1V11"
                    stroke={selectedIcon === 12 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* SIM */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 13 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(13)}
              >
                <svg
                  width="20"
                  height="27"
                  viewBox="0 0 20 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_671_3601)">
                    <path
                      d="M16.3234 14.0156H3.67758C3.27145 14.0156 2.94336 14.3504 2.94336 14.7649V23.253C2.94336 23.6674 3.27145 24.0022 3.67758 24.0022H16.3287C16.7349 24.0022 17.063 23.6674 17.063 23.253V14.7649C17.058 14.3504 16.7299 14.0156 16.3234 14.0156ZM15.5892 22.498H4.41214V20.8983H4.78719C5.19333 20.8983 5.52141 20.5635 5.52141 20.149C5.52141 19.7346 5.19333 19.3998 4.78719 19.3998H4.41214V17.9009H6.25597C6.66211 17.9009 6.99019 17.5661 6.99019 17.1517C6.99019 16.7372 6.66211 16.4024 6.25597 16.4024H4.41214V15.5148H15.5892V22.498Z"
                      fill={selectedIcon === 13 ? "#BEC5BF" : "black"}
                    />
                    <path
                      d="M5.11508 2.41309C4.70895 2.41309 4.38086 2.74789 4.38086 3.16234V6.48435C4.38086 6.8988 4.70895 7.239 5.11508 7.239C5.52122 7.239 5.84931 6.9042 5.84931 6.48975V3.16234C5.84931 2.74789 5.52122 2.41309 5.11508 2.41309Z"
                      fill={selectedIcon === 13 ? "#BEC5BF" : "black"}
                    />
                    <path
                      d="M8.59946 2.41309C8.19332 2.41309 7.86523 2.74789 7.86523 3.16234V6.48435C7.86523 6.8988 8.19332 7.239 8.59946 7.239C9.0056 7.239 9.33368 6.9042 9.33368 6.48975V3.16234C9.33368 2.74789 9.0056 2.41309 8.59946 2.41309Z"
                      fill={selectedIcon === 13 ? "#BEC5BF" : "black"}
                    />
                    <path
                      d="M12.078 2.41309C11.6718 2.41309 11.3438 2.74789 11.3438 3.16234V6.48435C11.3438 6.8988 11.6718 7.239 12.078 7.239C12.4841 7.239 12.8122 6.9042 12.8122 6.48975V3.16234C12.8122 2.74789 12.4841 2.41309 12.078 2.41309Z"
                      fill={selectedIcon === 13 ? "#BEC5BF" : "black"}
                    />
                    <path
                      d="M15.5624 2.41309C15.1563 2.41309 14.8282 2.74789 14.8282 3.16234V6.48435C14.8229 6.8988 15.1563 7.239 15.5624 7.239C15.9685 7.239 16.2966 6.9042 16.2966 6.48975V3.16234C16.297 2.74789 15.9685 2.41309 15.5624 2.41309Z"
                      fill={selectedIcon === 13 ? "#BEC5BF" : "black"}
                    />
                    <path
                      d="M20 9.49253V2.24809C20 1.0098 19.0105 0 17.797 0H3.00536C2.81254 0 2.62502 0.07965 2.48446 0.218025L0.213653 2.5299C0.0780527 2.66828 0 2.8593 0 3.06146V9.49253C0 10.3164 0.838405 10.2418 0.838405 10.2418V11.714C0.838405 11.714 0 11.6768 0 12.4632V24.7462C0 25.9902 0.989549 27 2.203 27H17.7917C19.0052 27 19.9947 25.9902 19.9947 24.7519V12.4635C19.9947 11.6292 19.1613 11.7143 19.1613 11.7143V10.2421C19.1669 10.2418 20 10.311 20 9.49253ZM18.5312 24.7465C18.5312 25.161 18.2031 25.4958 17.797 25.4958H2.203C1.79686 25.4958 1.46878 25.161 1.46878 24.7465V13.2131C1.46878 13.2131 2.30718 13.2236 2.30718 12.4639V9.49286C2.30718 8.71155 1.46878 8.74361 1.46878 8.74361V3.3696L3.30202 1.49884H17.7917C18.1978 1.49884 18.5259 1.83364 18.5259 2.24809V8.74294C18.4591 8.74294 17.6978 8.76049 17.6978 9.49219V12.4632C17.6978 13.2658 18.5312 13.2125 18.5312 13.2125V24.7465Z"
                      fill={selectedIcon === 13 ? "#BEC5BF" : "black"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_671_3601">
                      <rect width="20" height="27" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              {/* Phone */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 14 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(14)}
              >
                <svg
                  width="18"
                  height="25"
                  viewBox="0 0 18 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.7143 1H3.28571C2.02335 1 1 2.02335 1 3.28571V21.5714C1 22.8338 2.02335 23.8571 3.28571 23.8571H14.7143C15.9767 23.8571 17 22.8338 17 21.5714V3.28571C17 2.02335 15.9767 1 14.7143 1Z"
                    stroke={selectedIcon === 14 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 19.2861H9.01143"
                    stroke={selectedIcon === 14 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Toggle */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 15 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(15)}
              >
                <svg
                  width="26"
                  height="36"
                  viewBox="0 0 26 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 1H8C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15H16C19.866 15 23 11.866 23 8C23 4.13401 19.866 1 16 1Z"
                    stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
                    stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.1211 20.3398H9.12109C5.2551 20.3398 2.12109 23.4739 2.12109 27.3398C2.12109 31.2058 5.2551 34.3398 9.12109 34.3398H17.1211C20.9871 34.3398 24.1211 31.2058 24.1211 27.3398C24.1211 23.4739 20.9871 20.3398 17.1211 20.3398Z"
                    stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.1211 30.3398C18.7779 30.3398 20.1211 28.9967 20.1211 27.3398C20.1211 25.683 18.7779 24.3398 17.1211 24.3398C15.4642 24.3398 14.1211 25.683 14.1211 27.3398C14.1211 28.9967 15.4642 30.3398 17.1211 30.3398Z"
                    stroke={selectedIcon === 15 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Camera */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 16 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(16)}
              >
                <svg
                  width="26"
                  height="17"
                  viewBox="0 0 26 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25 3L17 8.5L25 14V3Z"
                    stroke={selectedIcon === 16 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8667 1H3.13333C1.95513 1 1 1.95939 1 3.14286V13.8571C1 15.0406 1.95513 16 3.13333 16H14.8667C16.0449 16 17 15.0406 17 13.8571V3.14286C17 1.95939 16.0449 1 14.8667 1Z"
                    stroke={selectedIcon === 16 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* Browser */}
              <div
                className={`diagnostic-icon ${
                  selectedIcon === 17 ? "selected" : ""
                }`}
                onClick={() => setSelectedIcon(17)}
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.1667 19.3333C15.2293 19.3333 19.3333 15.2293 19.3333 10.1667C19.3333 5.10406 15.2293 1 10.1667 1C5.10406 1 1 5.10406 1 10.1667C1 15.2293 5.10406 19.3333 10.1667 19.3333Z"
                    stroke={selectedIcon === 17 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1 10.167H19.3333"
                    stroke={selectedIcon === 17 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.1667 1C12.4595 3.51016 13.7625 6.7677 13.8333 10.1667C13.7625 13.5656 12.4595 16.8232 10.1667 19.3333C7.87383 16.8232 6.57081 13.5656 6.5 10.1667C6.57081 6.7677 7.87383 3.51016 10.1667 1Z"
                    stroke={selectedIcon === 17 ? "#BEC5BF" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div className="software-right-column">
          <div className="software-content">
            <div className="software-headline">
              <span className="software-number">60+</span>
              <span className="software-point">POINT</span>
            </div>

            <div className="software-subtitle">Software Tested</div>

            <div className="software-divider"></div>

            <div className="software-emphasis">
              The Peace Of Mind Of Thoroughness.
            </div>

            <div className="software-description">
              Upon Arrival At The WireOx Grading Facility. All Products Go
              Through An Automated Device Diagnostic Check Covering
              Functionality, Capacity, And Condition.
            </div>
          </div>
        </div>
      </div>

      {/* Device Grading Scales Section */}
      <div className="grading-scales-section">
        <div className="grading-content">
          <div className="grading-headline">
            <span className="grading-title-bold">DEVICE GRADING</span>
            <span className="grading-title-muted">SCALES</span>
          </div>

          <div className="grading-description">
            <p>
              Details Covering Each Grade Will Be Outlined In The Following
              Pages In The Guide.
            </p>
            <p>Select A Device Grade And Learn More About It.</p>
          </div>

          <div className="grading-buttons">
            <button
              className={`grading-button ${
                selectedGrade === "A" ? "selected" : ""
              }`}
              onClick={() => setSelectedGrade("A")}
            >
              Grade A
            </button>
            <button
              className={`grading-button ${
                selectedGrade === "B" ? "selected" : ""
              }`}
              onClick={() => setSelectedGrade("B")}
            >
              Grade B
            </button>
            <button
              className={`grading-button ${
                selectedGrade === "C" ? "selected" : ""
              }`}
              onClick={() => setSelectedGrade("C")}
            >
              Grade C
            </button>
            <button
              className={`grading-button ${
                selectedGrade === "D" ? "selected" : ""
              }`}
              onClick={() => setSelectedGrade("D")}
            >
              Grade D
            </button>
            <button
              className={`grading-button ${
                selectedGrade === "face-touch" ? "selected" : ""
              }`}
              onClick={() => setSelectedGrade("face-touch")}
            >
              <span>Face & Touch</span>
              <span>ID Issue</span>
            </button>
          </div>

          {/* Grade Detail Section */}
          {selectedGrade && (
            <div className="  ">
              <div className="grade-detail-container">
                {/* Left Panel - Dark Green */}
                <div className="grade-left-panel">
                  <div className="phone-images">
                    {/* Phone images */}
                    <img
                      src={groupImage}
                      alt="Phone Group"
                      className="phone-group-image"
                    />
                  </div>
                  <div className="grade-badge">
                    {/* Grade stamp */}
                    <img
                      src={
                        selectedGrade === "A"
                          ? gradeA
                          : selectedGrade === "B"
                          ? gradeB
                          : selectedGrade === "C"
                          ? gradeC
                          : selectedGrade === "D"
                          ? gradeD
                          : gradeFace
                      }
                      alt="Grade Stamp"
                      className="grade-stamp-image"
                    />
                  </div>
                </div>

                {/* Right Panel - Light Gray */}
                <div className="grade-right-panel">
                  <div className="grade-content">
                    <h2 className="grade-title">
                      {selectedGrade === "A" && "LIKE NEW CONDITION"}
                      {selectedGrade === "B" && "GOOD CONDITION"}
                      {selectedGrade === "C" && "FAIR CONDITION"}
                      {selectedGrade === "D" && "POOR CONDITION"}
                      {selectedGrade === "face-touch" &&
                        "FACE & TOUCH ID ISSUE"}
                    </h2>

                    <p className="grade-description">
                      {selectedGrade === "A" &&
                        'Grade A Devices Are In Like New Condition. However, Devices Are Used And Therefore May Show Light Signs Of Use On The Screen, Back Cover, Or Chassis. Devices That Have Zero Signs Of Use Are Graded As "New".'}
                      {selectedGrade === "B" &&
                        "Grade B Devices Are In Good Condition With Minor Signs Of Wear. These Devices May Have Light Scratches On The Screen Or Housing But Function Perfectly. All Features Work As Expected."}
                      {selectedGrade === "C" &&
                        "Grade C Devices Are In Fair Condition With Noticeable Signs Of Use. These Devices May Have Moderate Scratches, Scuffs, Or Minor Cosmetic Issues But Remain Fully Functional."}
                      {selectedGrade === "D" &&
                        "Grade D Devices Are In Poor Condition With Significant Signs Of Wear. These Devices May Have Heavy Scratches, Dents, Or Other Cosmetic Issues But Still Function."}
                      {selectedGrade === "face-touch" &&
                        "Devices With Face ID Or Touch ID Issues May Have Problems With Biometric Authentication. These Devices May Require Password Entry Instead Of Biometric Unlock."}
                    </p>

                    <div className="grade-images">
                      {/* Detail images */}
                      <img
                        src={aboveCondition}
                        alt="Above Condition"
                        className="detail-image"
                      />
                      <img
                        src={aboveGradingSpec}
                        alt="Above Grading Spec"
                        className="detail-image"
                      />
                    </div>

                    <div className="grade-info-sections">
                      <div className="info-section">
                        <div className="info-icon">
                          <img
                            src={besideCondition}
                            alt="Beside Condition"
                            className="beside-image"
                          />
                        </div>
                        <div className="info-content">
                          <h3 className="info-title">CONDITION STATUS</h3>
                          <ul className="info-list">
                            <li>Pre-Owned</li>
                            <li>
                              {selectedGrade === "A" && "Like New Condition"}
                              {selectedGrade === "B" && "Good Condition"}
                              {selectedGrade === "C" && "Fair Condition"}
                              {selectedGrade === "D" && "Poor Condition"}
                              {selectedGrade === "face-touch" &&
                                "Biometric Issues"}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="info-section">
                        <div className="info-icon">
                          <img
                            src={besideGradingSpec}
                            alt="Beside Grading Spec"
                            className="beside-image"
                          />
                        </div>
                        <div className="info-content">
                          <h3 className="info-title">GRADING SPECIFICATION</h3>
                          <ul className="info-list">
                            {selectedGrade === "A" && (
                              <>
                                <li>Little To No Scratches, No Cracks,</li>
                                <li>No Scuffs On Screen, And</li>
                                <li>Housing.</li>
                              </>
                            )}
                            {selectedGrade === "B" && (
                              <>
                                <li>Minor Scratches On Screen Or Housing,</li>
                                <li>Light Signs Of Wear, And</li>
                                <li>Fully Functional.</li>
                              </>
                            )}
                            {selectedGrade === "C" && (
                              <>
                                <li>Moderate Scratches And Scuffs,</li>
                                <li>Noticeable Signs Of Use, And</li>
                                <li>Good Functionality.</li>
                              </>
                            )}
                            {selectedGrade === "D" && (
                              <>
                                <li>Heavy Scratches And Dents,</li>
                                <li>Significant Cosmetic Issues, And</li>
                                <li>Basic Functionality.</li>
                              </>
                            )}
                            {selectedGrade === "face-touch" && (
                              <>
                                <li>Face ID Or Touch ID Not Working,</li>
                                <li>Password Authentication Required, And</li>
                                <li>Other Features Functional.</li>
                              </>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Quality Assurance Section */}
          <div className="quality-assurance-section">
            <div className="quality-images-row">
              <div className="quality-image-item">
                <img src={warranty} alt="Warranty" className="quality-image" />
              </div>
              <div className="quality-image-item">
                <img
                  src={dataWiped}
                  alt="Data Wiped"
                  className="quality-image"
                />
              </div>
              <div className="quality-image-item">
                <img src={noIcloud} alt="No iCloud" className="quality-image" />
              </div>
              <div className="quality-image-item">
                <img src={mdm} alt="MDM" className="quality-image" />
              </div>
              <div className="quality-image-item">
                <img src={hardware} alt="Hardware" className="quality-image" />
              </div>
              <div className="quality-image-item">
                <img
                  src={sixtyPoint}
                  alt="60 Point"
                  className="quality-image"
                />
              </div>
              <div className="quality-image-item">
                <img src={cleansn} alt="Clean" className="quality-image" />
              </div>
              <div className="quality-image-item">
                <img src={frp} alt="FRP" className="quality-image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreOwnedDevices;
